<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <form @submit.prevent="onSubmit()">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <label>Noted Cost Center:</label>
                        {{ costCenter }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-sm-12 form-group">
                        <label for="name">Subscription Name</label>
                        <input :class="{'is-invalid': $v.name.$invalid}" autocomplete="off" class="form-control"
                               placeholder="Subscription Name" v-model="name">
                        <span class="invalid-feedback"
                              v-if="$v.name">Please enter a name</span>
                    </div>
                    <div class="col-md-3 col-sm-12 form-group">
                        <label for="sl">SL</label>
                        <input :class="{'is-invalid': $v.sl.$invalid}" autocomplete="off" class="form-control"
                               maxLength="6" placeholder="SL Number" v-model="sl">
                        <span class="invalid-feedback"
                              v-if="$v.sl">Please enter a valid SL</span>
                    </div>
                    <div class="col-md-3 col-sm-12 form-group">
                        <label for="sa">SA</label>
                        <input :class="{'is-invalid': $v.sa.$invalid}" autocomplete="off" class="form-control"
                               maxlength="5" placeholder="SA number" v-model="sa">
                        <span class="invalid-feedback"
                              v-if="$v.sa">Please enter a valid SA</span>
                    </div>
                </div>
            </div>
            <div class="card-footer d-print-none text-right">
                <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                <RouterLink :disabled="isSubmitting"
                            :to="{name:'AzureBillingSubscriptions',params:{billingId:billingId}}"
                            class="btn btn-danger">Back
                </RouterLink>
            </div>
        </form>
    </AppLoadingContainer>
</template>

<script>
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import {maxLength, minLength, required} from "vuelidate/lib/validators";
    import AzureBillingService from "@/services/AzureBillingService";
    import {ToastType} from "@/services/models/shared/ToastType";

    export default {
        components: {
            AppLoadingContainer
        },
        data() {
            return {
                isSubmitting: false,
                isLoaded: false,
                name: null,
                sl: null,
                sa: null,
                costCenter: null
            }
        },
        props: {
            billingId: {
                type: String,
                required: true
            },
            subscriptionId: {
                type: String,
                required: true
            }
        },
        methods: {
            onSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.isSubmitting = true;
                AzureBillingService.updateSubscription(vm.billingId, vm.subscriptionId, {
                    name: vm.name,
                    sl: vm.sl,
                    sa: vm.sa
                })
                    .then(() => {
                        vm.alert(ToastType.Success, "The subscription was successfully updated")
                    }).catch(error => {
                    vm.alert(ToastType.Danger, error.response.statusText);
                }).finally(() => vm.isSubmitting = false);
            }
        },
        created() {
            const vm = this;
            AzureBillingService.getSubscription(this.billingId, this.subscriptionId)
                .then(function (response) {
                    vm.name = response.name;
                    vm.sl = response.sl;
                    vm.sa = response.sa;
                    vm.costCenter = response.costCenter;
                }).catch(() => {
                vm.redirectToError();
            }).finally(() => vm.isLoaded = true);
        },
        validations: {
            name: {
                required,
            },
            sl: {
                required,
                maxLength: maxLength(6),
                minLength: minLength(6)
            },
            sa: {
                required,
                maxLength: maxLength(5),
                minLength: minLength(5)
            }
        }
    }
</script>
